/**
 * All types that relation can be.
 */
export type RelationType =
    | "one-to-one"
    | "one-to-many"
    | "many-to-one"
    | "many-to-many"
